// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import {
  i18n
} from './locale'
import 'babel-polyfill' //解决ie打开空白问题
import './utils';
import App from './App' //放这防止css编译顺序问题

Vue.config.productionTip = false

Vue.prototype.goBack = function() {
  router.go(-1)
}
router.beforeEach((to, from, next) => {
  if (!to.meta.login) {
    const user_info = Vue.prototype.getSessionStorage('user_info');
    if (!user_info) {
      next({
        path: '/login'
      })
      return
    }
    next()
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: {
    App
  },
  template: '<App/>',
  beforeCreate() {
    // 挂载全局时间总线
    Vue.prototype.$bus = this;
    switch (this.$projectType) {
      case 1:
        document.title = 'Ordering';
        break;
      case 2:
        document.title = 'JustGreen ERP';
        break;
      case 3:
        document.title = '亿承源副食品配送平台系统';
        break;
      case 4:
        document.title = '优鲜云采生鲜配送系统';
        break;
      case 5:
        document.title = '展维美菜配送系统';
        break;
      case 6:
        document.title = '商仑供应链系统';
        break;
      default:
        document.title = this.$ts('蔬果云管理后台');
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js